import {PageBaseSection} from "../PageBaseSection";

export class PageSelectionSitSection extends PageBaseSection{
  selection_sit: string;
  filtres_sit: string;
  has_hide_map: boolean;
  has_hide_filters: boolean;
  url: string;
  nb_items: number;
}
